import { StateType } from "./context";
import { Actions } from "./types";
export enum mapsPayloadType {
  COMPANY = "COMPANY",
  COMPANY_ID = "COMPANY_ID",
  SUBSIDARY = "SUBSIDARY",
  ASSET = "ASSET",
  ITEM = "ITEM",
  ITEM_DETAILS_ID = "ITEM_DETAILS_ID",
  JUNCTION = "JUNCTION",
  SITE = "SITE",
  ASSET_TYPE_ID = "ASSET_TYPE_ID",
  TICKET = "TICKET",
  EMP = "EMP",
  ITEM_ID = "ITEM_ID",
  SUPPLIER_ID = "SUPPLIER_ID",
  TICKET_DETAILS = "TICKET_DETAILS",
  FOLLOW_UP_TICKET = "FOLLOW_UP_TICKET",
  LEDGER_ID = "LEDGER_ID",
  JUNCTION_STATUS = "JUNCTION_STATUS",
  JUNCTION_ID="JUNCTION_ID",
  JUNCTION_TYPE="JUNCTION_TYPE",
  RAISE_TICKET_LEVEL ="RAISE_TICKET_LEVEL"
}

export const reducer = (state: StateType, action: Actions) => {
  switch (action.type) {
    case mapsPayloadType.COMPANY:
      return {
        ...state,
        company: action.payload.company,
      };
    case mapsPayloadType.SUBSIDARY:
      return {
        ...state,
        subsidary: action.payload.subsidary,
      };
    case mapsPayloadType.ASSET:
      return {
        ...state,
        asset: action.payload.asset,
      };

    case mapsPayloadType.ITEM:
      return {
        ...state,
        item: action.payload.item,
      };

    case mapsPayloadType.JUNCTION:
      return {
        ...state,
        junction: action.payload.junction,
      };

    case mapsPayloadType.SITE:
      return {
        ...state,
        site: action.payload.site,
      };

    case mapsPayloadType.COMPANY_ID:
      return {
        ...state,
        companyId: action.payload.companyId,
      };

    case mapsPayloadType.ASSET_TYPE_ID:
      return {
        ...state,
        assetTypeId: action.payload.assetTypeId,
      };
    case mapsPayloadType.ITEM_ID:
      return {
        ...state,
        itemId: action.payload.itemId,
      };
    case mapsPayloadType.SUPPLIER_ID:
      return {
        ...state,
        supplierId: action.payload.supplierId,
      };
    case mapsPayloadType.TICKET:
      return {
        ...state,
        ticketId: action.payload.ticketId,
      };
    case mapsPayloadType.EMP:
      return {
        ...state,
        empId: action.payload.empId,
      };

    case mapsPayloadType.TICKET_DETAILS:
      return {
        ...state,
        ticketDetailsId: action.payload.ticketDetailsId,
      };

    case mapsPayloadType.FOLLOW_UP_TICKET:
      return {
        ...state,
        followUpTicket: action.payload.followUpTicket,
      };

    case mapsPayloadType.ITEM_DETAILS_ID:
      return {
        ...state,
        itemDetailsId: action.payload.itemDetailsId,
      };
    case mapsPayloadType.JUNCTION_STATUS: {
      return {
        ...state,
        junctionStatus: action.payload.junctionStatus,
      };
    }
    case mapsPayloadType.JUNCTION_ID: {
      return {
        ...state,
        junctionId: action.payload.junctionId,
      };
    }
    case mapsPayloadType.JUNCTION_TYPE: {
      return {
        ...state,
        junctionType: action.payload.junctionType,
      };
    }
    
    case mapsPayloadType.RAISE_TICKET_LEVEL: {
      return {
        ...state,
        raiseTicketLevel: action.payload.raiseTicketLevel,
      };
    }
    default:
      return state;
  }
};
